import { httpPost, httpDownload } from '../../../../utils/api.utils';
import {
    setEquipmentHistoryLogsLoading,
    getEquipmentHistoryLogs,
    setEquipmentHistoryPageSize,
    resetEquipmentHistory,
    setEquipmentHistoryColSearchStr
} from '../../../../constants/model-reducers/external/inventory/circuit-details/history/equipment-history.settings';

import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatLocalDate, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';

const defaultState = () => ({ 
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const equipmentHistoryActions = {
    getEquipmentHistoryLogs: (EquipmentId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().inventoryEquipmentHistory.HistoryTable;
        var formData = {
            EquipmentID: EquipmentId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
            TimeZone: getLocalTimeZone()
        };

        dispatch({
            type: setEquipmentHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost("external/inventory/getEquipmentHistoryLogs", formData);

        dispatch({
            type: getEquipmentHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },
    resizeEquipmentHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setEquipmentHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    setEquipmentHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().inventoryEquipmentHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setEquipmentHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },


    extractEquipmentHistoryLogs: (EquipmentId) => async (dispatch, state) => {
        const { Headers } = state().inventoryEquipmentHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        var filename = `ATEM ${dealName} Equipment History –  ${formattedTimeZoneDate}`;

        var formData = {
            EquipmentID: EquipmentId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/inventory/getExtractEquipmentHistory', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },


    resetEquipmentHistory: () => (dispatch, state) => {
        dispatch({
            type: resetEquipmentHistory
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setEquipmentHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getEquipmentHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setEquipmentHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setEquipmentHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetEquipmentHistory:
            return initialState;
        default:
            return state;
    }
}